import MatrixPageHeader from './MatrixPageHeader';

export default MatrixPageHeader;
